import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "serviceFilter",
})

export class ServiceFilterPipe implements PipeTransform {
  public transform( value: any[], searchString: string ) {
   if (!searchString) {
     return value;
   }

   const searchStringFormatted = searchString.toLowerCase();

   return value.filter( (it) => {
     const name = it.name ? it.name.toLowerCase().includes(searchStringFormatted) : false;
     const label = it.label ? it.label.toLowerCase().includes(searchStringFormatted) : false;
      const text = it.text ? it.text.toLowerCase().includes(searchStringFormatted) : false;
     const id = it.id ? it.id.toLowerCase().includes(searchStringFormatted) : false;
     const dbName = it.dbName ? it.dbName.toLowerCase().includes(searchStringFormatted) : false;
     return (name + label + text + dbName + id);
   });
  }
}
